import { useClasser } from "@code-hike/classer";
import * as React from "react";
export var SandpackStack = function SandpackStack(_ref) {
  var children = _ref.children,
      customStyle = _ref.customStyle;
  var c = useClasser("sp");
  return React.createElement("div", {
    className: c("stack"),
    style: customStyle
  }, children);
};